/**
 * MICD — Fec menos Fec Anterior Suavizado.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLOscilators.cs, classe
 * FML.MICD). Painel próprio, 2 linhas:
 *
 *   MI   = C − REF(C,1)
 *   AMI  = SMA(MI, N, 1)
 *   DIF  = MA(REF(AMI,1), N1) − MA(REF(AMI,1), N2)
 *   MICD = SMA(DIF, 10, 1)          (suavização final FIXA em 10 no engine)
 *
 * Paridade provada em __tests__/micd.silverlight.test.js.
 */
import { ref, sub, sma, ma } from "./silverlightDsl";
import { MICD as defaultOptions } from "./defaultOptionsForComputation";

const FINAL_SMOOTH = 10; // fixo no engine (SMA(DIF,10,1))

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, n1, n2 } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const mi = sub(close, ref(close, 1));
    const ami = sma(mi, period, 1);
    const amiPrev = ref(ami, 1);
    const dif = sub(ma(amiPrev, n1), ma(amiPrev, n2));
    const micd = sma(dif, FINAL_SMOOTH, 1);

    return dif.map((v, i) => {
      const difOut = Number.isFinite(v) ? v : undefined;
      const micdOut = Number.isFinite(micd[i]) ? micd[i] : undefined;
      if (difOut === undefined && micdOut === undefined) return undefined;
      return { dif: difOut, micd: micdOut };
    });
  }

  calculator.undefinedLength = function () {
    const { period, n2 } = options;
    // MI(1) + AMI(N-1) + REF(1) + MA(max(N1,N2)-1) — o warm-up efetivo é o do
    // ramo mais longo; a SMA final reinicia depois dos NaN (ver DSL.md).
    return Math.max(0, period + n2 + 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
